import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import { Formik, Form, ErrorMessage } from 'formik'
import Select from 'react-select'

const divStyle = {
  float: 'left',
  paddingLeft: '0px',
}

const aStyle = {
  display: 'none',
}

const optionsHour = [
  { value: '0', label: '00' },
  { value: '1', label: '01' },
  { value: '2', label: '02' },
  { value: '3', label: '03' },
  { value: '4', label: '04' },
  { value: '5', label: '05' },
  { value: '6', label: '06' },
  { value: '7', label: '07' },
  { value: '8', label: '08' },
  { value: '9', label: '09' },
  { value: '10', label: '10' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
  { value: '13', label: '13' },
  { value: '14', label: '14' },
  { value: '15', label: '15' },
  { value: '16', label: '16' },
  { value: '17', label: '17' },
  { value: '18', label: '18' },
  { value: '19', label: '19' },
  { value: '20', label: '20' },
  { value: '21', label: '21' },
  { value: '22', label: '22' },
  { value: '23', label: '23' },
]

const optionsMinutes = [
  { value: '0', label: '00' },
  { value: '5', label: '05' },
  { value: '10', label: '10' },
  { value: '15', label: '15' },
  { value: '20', label: '20' },
  { value: '25', label: '25' },
  { value: '30', label: '30' },
  { value: '35', label: '35' },
  { value: '40', label: '40' },
  { value: '45', label: '45' },
  { value: '50', label: '50' },
  { value: '55', label: '55' },
]

const optionsDay = [
  { value: '0', label: 'Day with on-call' },
  { value: '1', label: 'Day before on-call' },
]

const ReminderForm = props => <Formik initialValues={{ id: props.reminder.id, reminder_day: 0, reminder_hour: 8, reminder_minutes: 30 }} enableReinitialize={true} validate={values => {
      const errors = {}
      const selD = document.getElementById('myday')
      values.reminder_day = selD.childNodes[1].value
      const selH = document.getElementById('myhour')
      values.reminder_hour = selH.childNodes[1].value
      const selM = document.getElementById('myminutes')
      values.reminder_minutes = selM.childNodes[1].value
      if (!values.reminder_day) {
        errors.reminder_day = 'Required'
      } else if (!values.reminder_hour) {
        errors.reminder_hour = 'Required'
      } else if (!values.reminder_minutes) {
        errors.reminder_minutes = 'Required'
      }
      return errors
    }} onSubmit={(values, { setSubmitting }) => {
      const formData = new FormData()
      formData.append('reminder_day', values.reminder_day)
      formData.append('reminder_hour', values.reminder_hour)
      formData.append('reminder_minutes', values.reminder_minutes)
      const urlf = '/api/v1/reminder/' + values.id
      const meth = 'POST'
      fetch(urlf, {
        method: meth,
        body: formData,
      })
      .then(response => response.json())
      .then(() => {
        document.getElementById('mylink').click()
      })
      .catch((err) => {
        console.error('Error while setting reminder! ' + err)
      })
      setTimeout(() => {
        setSubmitting(false)
      }, 400)
    }}>{({ isSubmitting}) => <Fragment><a href={'/teams/' + props.reminder.id} id="mylink" style={aStyle}></a><div className="row col-sm-12 justify-content-top"><h3>Set reminder</h3></div><br /><Form><div className="row col-sm-12"><div className="col-sm-12" style={divStyle}><div><label htmlFor="reminder_day">Day</label><br /><Select id="myday" name="reminder_day" options={optionsDay} defaultValue={optionsDay[0]}></Select></div><ErrorMessage name="reminder_day" component="div"></ErrorMessage><br /></div><div className="col-sm-6" style={divStyle}><div><label htmlFor="reminder_hour">Hour</label><br /><Select id="myhour" name="reminder_hour" options={optionsHour} defaultValue={optionsHour[0]}></Select></div><ErrorMessage name="reminder_hour" component="div"></ErrorMessage><br /></div><div className="col-sm-6" style={divStyle}><div><label htmlFor="reminder_minutes">Minutes</label><br /><Select id="myminutes" name="reminder_minutes" options={optionsMinutes} defaultValue={optionsMinutes[0]}></Select></div><ErrorMessage name="reminder_minutes" component="div"></ErrorMessage><br /></div><button type="submit" disabled={isSubmitting}>Set reminder</button><br /><br /></div></Form></Fragment>}</Formik>

ReminderForm.propTypes = {
  reminder: PropTypes.object,
}

export default ReminderForm
